/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-filename-extension */
import React, { Component } from 'react';

import Fade from 'react-reveal/Fade';
import Header from 'parts/Header';
import Technologies from 'parts/Technologies';
import EnterpriseSupport from 'parts/EnterpriseSupport';
import Discuss from 'parts/Discuss';
import Footer from 'parts/Footer';

import Data from 'json/landingPage.json';

export default class TechnologiesPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    const techCategories = [
      {
        title: 'Front-end Engineering',
        description: 'Make Your Digital Product stand out with impressive features and an appealing interface built by ERapid\'s expert front-end developers. Our proficient developers use cutting-edge technologies namely JavaScript, React.JS, Vue JS, CSS, and Bootstrap to build high-performance software that aligns with your business objectives.',
        icon: '💻',
      },
      {
        title: 'Backend Engineering',
        description: 'Our back-end development team builds a reliable back end for your product and ensures that you and your users get a seamless user experience. We leverage top-notch back-end technologies including Golang, Rust, Node.JS, Java, Python, etc.',
        icon: '⚙️',
      },
      {
        title: 'UI/UX',
        description: 'Our Creative UI/UX Designers incorporate the best UX design practices to provide you with the finest interfaces that complement your brand image and enable easy navigation for your users, AdobeXD, Figma, Framer, Axure, and Sketch are some of the best UI/UX tools we have in our stack.',
        icon: '🎨',
      },
      {
        title: 'AI/ML',
        description: 'By utilizing the most complimenting AI & ML technologies such as Auto ML, PyTorch, Tensor Flow, etc. to build intelligent ML models and algorithms that help you to transform processes, identify opportunities and increase profitability.',
        icon: '🤖',
      },
      {
        title: 'Testing',
        description: 'We use both manual and automated testing approaches to identify any vulnerabilities in your application. Our in-house testing experts use cross-browser testing, Sauce labs, TestMO, Xray, and other automated testing platforms to ensure the high-in-standard quality and reliability of your applications.',
        icon: '🧪',
      },
      {
        title: 'Database',
        description: 'Our database development team is well versed in MySQL, Neo4j, MongoDB, SQL, PostgreSQL, and Redis, hence we offer you secure and quick database solutions that help you to streamline your business\'s workflows and boost its growth.',
        icon: '🗄️',
      },
      {
        title: 'DevOps',
        description: 'With outstanding and advanced tools in our tech stack, we empower your business to bridge the gap between operations and developments. Jira, Git, Docker, Jenkins, AWS, and Kubernetes are some fabulous DevOps we use for the best results.',
        icon: '🚀',
      },
      {
        title: 'Others',
        description: 'We leverage the versatility of WordPress for web content, orchestrate scalability with Kubernetes, craft mobile apps using Android Studio and Xcode, and bridge web-mobile experiences with Cordova. These tools power our innovative solutions.',
        icon: '🔧',
      },
    ];

    return (
      <>
        <Header {...this.props} />
        <section className="pt-32 pb-16 bg-gradient-to-b from-white to-gray-50">
          <div className="container mx-auto px-4">
            <Fade bottom>
              <h1 className="text-5xl lg:text-6xl text-theme-blue text-center font-bold mb-4">
                Technologies
              </h1>
              <p className="font-light text-lg lg:text-xl text-gray-600 text-center mb-12 max-w-3xl mx-auto">
                Explore the cutting-edge technologies and tools we use to build innovative
                solutions for your business.
              </p>
            </Fade>
          </div>
        </section>

        <section className="py-16 bg-white">
          <div className="container mx-auto px-4">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
              {techCategories.map((category, index) => (
                <Fade bottom delay={200 * index} key={category.title}>
                  <div className="bg-white rounded-xl shadow-md border border-gray-100 p-6 transform transition-all duration-300 hover:shadow-xl hover:scale-105 h-full">
                    <div className="text-4xl mb-4">{category.icon}</div>
                    <h3 className="text-xl font-semibold text-theme-blue mb-3">
                      {category.title}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {category.description}
                    </p>
                  </div>
                </Fade>
              ))}
            </div>
          </div>
        </section>

        <div className="pt-0 pb-16 bg-gray-50">
          <Technologies data={Data.technologies} />
        </div>

        <EnterpriseSupport data={Data.enterpriseSupport} />
        <Discuss {...this.props} />
        <Footer />
      </>
    );
  }
}
